import Header from '../Header'

function Contact(){
  return (
    <>
      <Header />
      <h4>Esta sección aún se encuentra en construcción.</h4>
    </>
  )
}

export default Contact